<template>
  <div class="jin-pc-tabbar jin-pc" :class="{'fix-btn-bg':isShowTabBg || $route.meta.active!=='首页'}">
    <div class="jin-pc-tabbar-con jin-pc-container">
      <div class="jin-pc-tab-con">
        <img class="logo" src="@/assets/logo.png" alt="">
        <ul class="jin-pc-tab-warp">
          <li v-for="item in tab" :key="item.name" :class="{'jin-pc-tab-active' : item.name === active && isShowTabBg}" class="jin-pc-tab-item" @click="clickTab(item)">{{ item.name }}</li>
        </ul>
      </div>
      <div v-if="userInfo && userInfo.nick" class="jin-pc-tab-userInfo">
        <div class="info">
          <img :src="userInfo.avatar" alt="">
          <span class="jin-pc-tab-nickname">{{ userInfo.nick }}</span>
        </div>
        <ul class="jin-pc-tab-return">
          <li @click="onLogout">退出登录</li>
        </ul>
      </div>
      <span v-else class="jin-pc-tab-login">
        <a href="javascript:" @click="onLogin">登录</a> /
        <a href="javascript:" @click="onReg">注册</a>
      </span>
    </div>
  </div>
</template>

<script>
import members from '@/utils/user'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      active: '',
      isShowTabBg: false,
      productOffsetTop: 0,
      tab: [
        {
          url: '/',
          name: '首页'
        },
        {
          url: '/list?attributes=1',
          name: '社会招聘'
        },
        {
          url: '/list?attributes=0',
          name: '校园招聘'
        },
        {
          url: '/',
          name: '文化福利'
        },
        {
          url: '/aboutDetails/Info',
          name: '了解金十'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'resumeList'
    ]),
    headActive() {
      return this.$route.meta.active
    }
  },
  watch: {
    headActive: {
      handler() {
        this.init()
      },
      deep: true
    }
  },
  async created() {
    await this.init()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    setTimeout(() => {
      this.productOffsetTop = document.querySelector('.jin-product')?.offsetTop
    }, 500)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.handleScroll) // 移除页面滚动事件
  },
  methods: {
    init() {
      if (this.headActive) {
        this.active = this.headActive
      } else {
        const path = this.$route.path
        if (path.includes('list')) {
          const { attributes } = this.$route.query
          this.active = Number(attributes) === 1 ? '社会招聘' : '校园招聘'
        }
      }
    },
    getInfo() {
      // this.GET_USER()
    },
    onLogin() {
      members.showLogin()
    },
    onReg() {
      members.showRegister()
    },
    onLogout() {
      members.logout()
      // this.getInfo()
    },
    handleScroll() {
      const _scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop
      this.isShowTabBg = _scrollTop > this.productOffsetTop
    },
    clickTab({ name, url }) {
      this.active = name
      if (name === '文化福利') {
        const welfareElTop = sessionStorage.getItem('welfareElTop')
        this.$router.push(url)
        setTimeout(() => window.scrollTo(0, welfareElTop - 100), 200)
      } else {
        this.$router.push(url)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.jin-pc {
  &-tabbar {
    width: 100%;
    height: 60px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    // background: #4777f4;
    .jin-pc-tabbar-con {
      font-size: 16px;
    }
    &-con {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 16.7%;

      img.logo {
        height: 30px;
        margin-right: 37px;
        cursor: pointer;
      }
    }
  }

  &-tab {
    &-con {
      display: flex;
      align-items: center;
    }

    &-warp {
      display: flex;

      li {
        cursor: pointer;
        margin-right: 22px;
        padding: 4px 14px;
        border-radius: 15px;
        color: #fff;
        font-weight: 500;
      }
    }

    &-active {
      background: #3E66D3;
    }

    &-userInfo {
      cursor: pointer;
      color: #fff;
      font-weight: 500;

      &:hover {
        .jin-pc-tab-return {
          visibility: visible;
          top: 106%;
          opacity: 1;
        }
      }

      .info {
        display: flex;
        align-items: center;

        img {
          height: 40px;
          width: 40px;
          border-radius: 50%;
          margin-right: 10px;
          object-fit: cover;
        }
      }
    }

    &-login {
      cursor: pointer;
      font-weight: 500;
      color: #fff;

      a {
        color: #fff;
      }
    }

    &-return {
      background: #fff;
      padding: 6px 0;
      box-shadow: 0 2px 6px 0 rgba(34, 46, 80, 0.1);
      border-radius: 4px;
      color: #787b8a;
      position: absolute;
      top: 90%;
      transition: all 0.3s;
      visibility: hidden;
      opacity: 0;

      li {
        width: 120px;
        height: 36px;
        line-height: 35px;
        color: #3d4351;
        text-align: center;
      }
    }
  }
}
.fix-btn-bg {
  background: #4777f4;
  transition: background-color .6s;
}

</style>
